/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: aeeb275c (Fri Jul 31 21:53:12 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Transcript, TranscriptFromJSON, TranscriptToJSON } from './'

/**
 * The response body that is returned after a transcript is updated.
 * @export
 * @interface UpdateTranscriptResponseBody
 */
export interface UpdateTranscriptResponseBody {
  /**
   *
   * @type Transcript
   * @memberof UpdateTranscriptResponseBody
   */
  transcript?: Transcript
}

export function UpdateTranscriptResponseBodyFromJSON(
  json: any
): UpdateTranscriptResponseBody {
  return UpdateTranscriptResponseBodyFromJSONTyped(json, false)
}

export function UpdateTranscriptResponseBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateTranscriptResponseBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    transcript: !exists(json, 'transcript')
      ? undefined
      : TranscriptFromJSON(json['transcript']),
  }
}

export function UpdateTranscriptResponseBodyToJSON(
  value?: UpdateTranscriptResponseBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    transcript: TranscriptToJSON(value.transcript),
  }
}
